// @flow
import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'Components/Grid';
import DefaultPage from 'Containers/DefaultPage';
import HeroHeader from 'Components/HeroHeader/deprecated';
import RichText from 'Components/RichText';
import Gallery from 'Components/Gallery';
import IntroText from 'Components/IntroText';
import AboutUsModel from 'Stores/AboutUsModel';
import { getGivenBackground } from 'Utils/getColor';

const AboutUs = ({ data, deeplinkId }) => {
  const aboutUs = new AboutUsModel(data);

  return (
    <DefaultPage background={getGivenBackground('white')} deeplinkId={deeplinkId}>
      {/* could be a mood image with MAZ-2433 */}
      <HeroHeader image={aboutUs.image} />
      <IntroText
        headline={{ value: aboutUs.title, level: 'h1', forceUppercase: true }}
        bodyText={aboutUs.intro}
      />
      <Container>
        <Row align="center">
          <Col cols={12} l={8}>
            <RichText content={aboutUs.text} />
          </Col>
        </Row>
      </Container>
      {!aboutUs.gallery.empty() && <Gallery images={aboutUs.gallery.items} />}
    </DefaultPage>
  );
};

AboutUs.propTypes = {
  data: PropTypes.object,
  deeplinkId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default AboutUs;
